import { deleteDoc, doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const getUserNoteRef = (userId, recipeId) => doc(db, "users", userId, "notes", recipeId);

export const getUserRecipeNote = async (userId, recipeId) => {
  try {
    const noteSnapshot = await getDoc(getUserNoteRef(userId, recipeId));

    if (!noteSnapshot.exists()) {
      return null;
    }

    return {
      id: noteSnapshot.id,
      ...noteSnapshot.data(),
    };
  } catch (error) {
    console.error("Error fetching recipe note:", error);
    throw error;
  }
};

export const saveUserRecipeNote = async (userId, recipeId, note) => {
  try {
    const noteRef = getUserNoteRef(userId, recipeId);
    const noteText = typeof note === "string" ? note : "";
    const trimmedNote = noteText.trim();

    if (trimmedNote === "") {
      await deleteDoc(noteRef);
      return;
    }

    await setDoc(noteRef, {
      recipeId,
      note: noteText,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving recipe note:", error);
    throw error;
  }
};
